import AccountSidebar from './AccountSidebar'
import FAQContent from './BuyTokens/FAQContent'
import Footer from '/web/shared/aifans/Footer'
import HeaderContainer from '/web/shared/aifans/HeaderContainer'
import { Title, Meta } from '@solidjs/meta'

export default function FAQ() {
  return (
    <>
      <Title>CosplayFans - FAQ | Get Answers About Fan Pages</Title>
      <Meta name="og:title" content="CosplayFans - FAQ | Get Answers About Fan Pages" />
      <Meta
        name="description"
        content="Find answers to frequently asked questions about CosplayFans.ai features including exclusive content, live chat, ai generated images, subscriptions & support."
      />
      <Meta
        name="og:description"
        content="Find answers to frequently asked questions about CosplayFans.ai features including exclusive content, live chat, ai generated images, subscriptions & support."
      />
      <HeaderContainer />
      <main class="faq page-bg relative min-h-screen overflow-hidden bg-main pb-20 pt-20 font-normal sm:pt-28 md:bg-none md:pb-36">
        <div class="container relative z-20">
          <div class="wrapper gap-8 lg:flex">
            <AccountSidebar openHelp />

            {/* right */}
            <div class="right flex w-full flex-col">
              <FAQContent />
            </div>
          </div>
        </div>

        {/* bg */}
        <div class="radial-bg bottom-[-40%] left-[-250px] right-0 h-[1000px] w-[900px] opacity-10 md:hidden"></div>
      </main>
      <Footer />
    </>
  )
}
